module.exports = __webpack_public_path__ + "static/media/emergency-icon.ab728340.svg";